module.exports = "/images/lonewolf_logo.png?f238354c79570f4048e1995c39c3b0a2";